import { FormattedMessage } from 'react-intl';
import { NotificationOrigin } from '@synergy/models';
import { PaloNotificationDocument, PaloNotificationSettings } from '@synergy/components-palo';
import { ReactElement, useEffect } from 'react';

import {
    createNotification,
    deleteNotification,
    fetchNotifications,
} from '../../../common/actions/notifications-actions';
import { useSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

/**
 * The documents a supplier receives (#2284, the same rules as for members per
 * GF 15.10.2026). A demand survey never goes to a supplier, so it is not listed
 * even where an old rule for one exists (R-158).
 */
const DOCUMENTS: PaloNotificationDocument[] = [
    {
        origin: NotificationOrigin.PurchaseOrderShop,
        title: <FormattedMessage id="app.notifications.palo.supplier.shopOrder" />,
        hint: <FormattedMessage id="app.notifications.palo.supplier.shopOrder.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.companyEmail" />,
    },
    {
        origin: NotificationOrigin.PurchaseOrderManual,
        title: <FormattedMessage id="app.notifications.palo.supplier.poolOrder" />,
        hint: <FormattedMessage id="app.notifications.palo.supplier.poolOrder.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.supplier.poolOrder.standard" />,
    },
    {
        origin: NotificationOrigin.Invoice,
        standard: <FormattedMessage id="app.notifications.palo.supplier.invoice.standard" />,
    },
    {
        origin: NotificationOrigin.Inquiry,
        hint: <FormattedMessage id="app.notifications.palo.supplier.inquiry.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.supplier.inquiry.standard" />,
    },
    {
        origin: NotificationOrigin.Import,
        hint: <FormattedMessage id="app.notifications.palo.supplier.import.hint" />,
        standard: <FormattedMessage id="app.notifications.palo.companyEmail" />,
    },
];

export const PaloNotifications = (): ReactElement => {
    const dispatch = useThunkDispatch();
    const settings = useSelector(state => state.notifications.notifications);

    useEffect(() => {
        dispatch(fetchNotifications());
    }, [dispatch]);

    return (
        <PaloNotificationSettings
            title={<FormattedMessage id="app.navigation.notifications" />}
            documents={DOCUMENTS}
            settings={settings}
            onAdd={(origin, email) =>
                dispatch(createNotification({ notificationOrigin: origin, recipientEmail: email }))
            }
            onRemove={id => dispatch(deleteNotification(id))}
        />
    );
};
